module.exports = __webpack_public_path__ + "media/entities/1604-ccc389b4.png";